import { render, staticRenderFns } from "./PuzzleForTeacher.vue?vue&type=template&id=deb093b6&scoped=true&"
import script from "./PuzzleForTeacher.vue?vue&type=script&lang=js&"
export * from "./PuzzleForTeacher.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleForTeacher.vue?vue&type=style&index=0&id=deb093b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb093b6",
  null
  
)

export default component.exports